import type {GenderCode} from '@common/gender';
import {MEMBER_ONLY_FIELDS, ADDRESS_ONLY_FIELDS} from '../member-fields';
export type {MemberFieldDef} from '../member-fields';
export {
  MEMBER_FIELDS,
  MEMBER_ONLY_FIELDS,
  ADDRESS_ONLY_FIELDS,
  getLabelForKey,
} from '../member-fields';

// Product assignment happens through the analyzer flow after member creation,
// so the default wizard has no product-selection steps. Champ is the exception:
// its groups still assign products at creation time.
export const STEPS = ['Member Info', 'Group & Coverage', 'Review & Confirm'] as const;

export const CHAMP_STEPS = [
  'Member Info',
  'Group & Coverage',
  'Additional Products',
  'Review & Confirm',
] as const;

export type StepName = (typeof CHAMP_STEPS)[number];

type MemberKey = (typeof MEMBER_ONLY_FIELDS)[number]['key'];
type AddressKey = (typeof ADDRESS_ONLY_FIELDS)[number]['key'];

export type MemberInfo = Record<Exclude<MemberKey, 'sexCode'>, string> & {
  sexCode: GenderCode | '';
};

export type AddressInfo = Record<AddressKey, string>;

export const INITIAL_MEMBER: MemberInfo = Object.fromEntries(
  MEMBER_ONLY_FIELDS.map((f) => [f.key, '']),
) as MemberInfo;

export const INITIAL_ADDRESS: AddressInfo = Object.fromEntries(
  ADDRESS_ONLY_FIELDS.map((f) => [f.key, '']),
) as AddressInfo;
